// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__v4PJh","search":"IconButton_search__FXST5","spin":"IconButton_spin__1rOSv"};